var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "isolated-device-options" },
    [
      _c("div", { staticClass: "isolated-device-options__row" }, [
        _c("div", { staticClass: "small-8 " }, [
          _c("label", { staticClass: "isolated-device-options__label" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectAllStatus,
                  expression: "selectAllStatus",
                },
              ],
              staticClass: "isolated-device-options__checkbox",
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.selectAllStatus)
                  ? _vm._i(_vm.selectAllStatus, null) > -1
                  : _vm.selectAllStatus,
              },
              on: {
                click: function () {
                  return _vm.selectAll()
                },
                change: function ($event) {
                  var $$a = _vm.selectAllStatus,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.selectAllStatus = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selectAllStatus = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selectAllStatus = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("action.selectAll")))]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.workPermitPreSetList, function (item, key) {
        return _c(
          "div",
          { key: key, staticClass: "isolated-device-options__row" },
          [
            _c("div", { staticClass: "small-8 " }, [
              _c("label", { staticClass: "isolated-device-options__label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.preSetCheckBox,
                      expression: "preSetCheckBox",
                    },
                  ],
                  staticClass: "isolated-device-options__checkbox",
                  attrs: { type: "checkbox" },
                  domProps: {
                    value: key,
                    checked: Array.isArray(_vm.preSetCheckBox)
                      ? _vm._i(_vm.preSetCheckBox, key) > -1
                      : _vm.preSetCheckBox,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.preSetCheckBox,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = key,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.preSetCheckBox = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.preSetCheckBox = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.preSetCheckBox = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(item.text))]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "small-10 isolated-device-options__input-box align-right",
              },
              [
                item.showRemarks
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.preSetRemarks[key],
                          expression: "preSetRemarks[key]",
                        },
                      ],
                      staticClass: "isolated-device-options__input",
                      attrs: {
                        disabled: _vm.getInputDisabledStatus(key),
                        type: "text",
                      },
                      domProps: { value: _vm.preSetRemarks[key] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.preSetRemarks, key, $event.target.value)
                        },
                      },
                    })
                  : _vm._e(),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }